import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Loader from '../components/Loader/Loader';
import { isLoading } from '../slice/commonSlice';

const AdminLayout = ({ children }) => {
  const loading = useSelector(isLoading);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const adminParam = searchParams.get("admin-Access"); // ?admin=true

  useEffect(() => {
    if (adminParam !== "true") {
      // Agar URL me admin param true nahi hai → redirect to login
      navigate("/");
    }
  }, [adminParam, navigate]);

  if (loading) return <Loader />;

  // Agar admin param true hai → content render karo
  if (adminParam === "true") {
    return <>{children}</>;
  }

  // Param false ya missing → render nothing
  return null;
};

export default AdminLayout;
